import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import ProductCard from "./ProductCard";
import LoadingSpinner from "./components/LoadingSpinner";
import "./App.css";
import { getOrFetch } from "./utils/apiCache";

function LatestProducts() {
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setIsLoading(true);
        const data = await getOrFetch(
          "latest:per_page:4",
          () =>
            axios
              .get("https://floriakw.com/wp-json/wc/v3/products", {
                auth: {
                  username: "ck_39cd5450af63b97a35e502d9a0a75925866fefab",
                  password: "cs_15701bd9b4392a3b6e5a3d5fa4d326d7acb0a0bf",
                },
                params: {
                  orderby: "date",
                  order: "desc",
                  per_page: 4,
                  status: "publish",
                },
              })
              .then((r) => r.data),
          { ttlMs: 10 * 60 * 1000 }
        );
        setProducts(data);
        setError(null);
      } catch (err) {
        console.error("Latest products error:", err);
        setError("فشل في تحميل المنتجات. يرجى المحاولة مرة أخرى لاحقًا.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (isLoading) {
    return (
      <section className="featured-section">
        <div className="container">
          <div className="featured-header">
            <h2>الأحدث وصولا</h2>
          </div>
          <LoadingSpinner size="medium" color="black" withText={true} />
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="featured-section">
        <div className="container">
          <div className="featured-header">
            <h2>الأحدث وصولا</h2>
          </div>
          <div className="error-message">
            <p>{error}</p>
            <button 
              onClick={() => window.location.reload()} 
              className="retry-button"
            >
              إعادة المحاولة
            </button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="featured-section">
      <div className="container">
        <div className="featured-header">
          <h2>الأحدث وصولا</h2>
          <Link to="/latest" className="view-all">
            عرض الجميع
          </Link>
        </div>

        {products.length > 0 ? (
          <div className="grid">
            {products.map((p) => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        ) : (
          <div className="no-products">
            <p>لا توجد منتجات متاحة حاليًا</p>
          </div>
        )}
      </div>
    </section>
  );
}

export default LatestProducts;
